var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rph-header-location-wrapper"},[_c('button',{staticClass:"address-btn rph-location-button-filled secondary",on:{"click":_vm.selectAddress}},[_c('LocationIcon'),_vm._v("\n    "+_vm._s(_vm.city?.title)+"\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }